/**
 * CDMX Scripts 2022
 * Common Header Scripts
 */

$('[data-bs-toggle="tooltip"]').tooltip();
$('[data-toggle="dropdown"]').dropdown()

// Toggle animation for Dropdown menu
$('.dropdown').on('show.bs.dropdown', function(e) {
    $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
});
$('.dropdown').on('hide.bs.dropdown', function(e) {
    $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
});